export default __webpack_public_path__ + "static/media/no_artworks.dc9208c1.svg";